/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import { useAppDispatch, useAuthState, useStudioState } from '@core/configureStore';
import { Divider, Space } from 'antd';
import { MIDDLE_STYLE } from '@constants/responsive';
import SocialPostCard from './SocialPostCard';
import LoadableContainer from '@components/LoadableContainer';
import { formatUtcTimestamp } from '@utils/date.util';
import pluralize from 'pluralize';
import { fetchSocialPosts } from '@core/features/studio/thunks';

type Props = {};

const SocialPostsTab = (props: Props) => {
  const dispatch = useAppDispatch();
  const { user } = useAuthState();
  const { socialPosts } = useStudioState();
  const locationId = useMemo(() => user?.selected_location.location_id, [user]);

  useEffect(() => {
    const init = async () => {
      if (!locationId) return;
      await dispatch(fetchSocialPosts({ locationId }));
    };
    init();
  }, [locationId]);

  const sortedSocialPosts = useMemo(
    () =>
      [...socialPosts].sort(
        (postA, postB) =>
          formatUtcTimestamp(postA.publish_at) - formatUtcTimestamp(postB.publish_at)
      ),
    [socialPosts]
  );

  return (
    <LoadableContainer isLoading={!locationId} loadComponent={<div>No location found</div>}>
      <React.Fragment>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <p>
            There are {socialPosts.length} social {pluralize('post', socialPosts.length)} found
          </p>
          <div></div>
        </div>
        <Divider />
        <Space style={{ ...MIDDLE_STYLE, flexWrap: 'wrap', marginTop: 20 }}>
          {sortedSocialPosts.map(socialPost => (
            <SocialPostCard socialPost={socialPost} locationId={locationId as any} />
          ))}
        </Space>
      </React.Fragment>
    </LoadableContainer>
  );
};

export default SocialPostsTab;
